import React, { useEffect, useState } from 'react';
import { translate } from '../../../services/translate';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';
import { accessService } from '../../../services/central-api/access';

interface Props {
    value: number;
    setValue: React.Dispatch<React.SetStateAction<number>>;
    zIndex: number;
}

function TagDropdown({ value, setValue, zIndex }: Props) {
    const [selectableTags, setSelectableTags] = useState<{ label: string; value: number; }[]>([]);

    async function loadTags() {
        try {
            const tags = await accessService.getUserTags();
            setSelectableTags((tags || []).map((tag) => ({
                value: tag.id || 0,
                label: tag.name
            })));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        loadTags();
    }, []);

    return (
        <FilterDropdown
            label={translate('userTag')}
            items={selectableTags}
            setValue={setValue}
            value={value}
            zIndex={zIndex}
        />
    );
}

export default TagDropdown;
